import { environment } from './../../../environments/environment';



let localhost = {
	url: "http://localhost:3700/api/",
	url_user: "http://localhost:3700/api-users/",
	url_auth: 'http://localhost:3700/api-auth/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	url_seguros: 'http://localhost:3700/api-seguros/',
	version: "1.1.0.18"
}

let dev = {
	url:  'https://api-seguros-dev.adventistas.cl/api/',
	url_user: "https://api-seguros-dev.adventistas.cl/api-users/",
	url_auth: 'https://api-seguros-dev.adventistas.cl/api-auth/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	url_seguros: 'https://api-seguros-dev.adventistas.cl/api-seguros/',
	version: "1.1.0.18"
}

let test= {
	url:  'https://api-seguros-staging.adventistas.cl/api/',
	url_user: "https://api-seguros-staging.adventistas.cl/api-users/",
	url_auth: 'https://api-seguros-staging.adventistas.cl/api-auth/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	url_seguros: 'https://api-seguros-staging.adventistas.cl/api-seguros/',
	version: "1.1.0.18"
}

let prod = {
	url:  'https://api-seguros.adventistas.cl/api/',
	url_user: "https://api-seguros.adventistas.cl/api-users/",
	url_auth: 'https://api-seguros.adventistas.cl/api-auth/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	url_seguros: 'https://api-seguros.adventistas.cl/api-seguros/',
	version: "1.1.0.18"
}

export var Global = environment.env == 'Staging' ? test : (environment.env== 'Production'?prod:(environment.env== 'Development'?dev:localhost))
